/* eslint-disable import/no-cycle */
import axios from 'axios';
import { i18n } from '@/boot/i18n';
import store from '@/utils/store';
import { setSentryTag } from '@/boot/sentry';

const http = axios.create({
  baseURL: process.env.ENDPOINT,
});

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(token) {
  refreshSubscribers.map((cb) => cb(token));

  refreshSubscribers = [];
}

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function addSubscribeTokenRefresh(request) {
  request.retry = true;

  return new Promise((resolve) => {
    subscribeTokenRefresh((token) => {
      request.headers.Authorization = `Bearer ${token}`;

      resolve(http(request));
    });
  });
}

http.interceptors.request.use((request) => {
  const transactionId = Math.random().toString(36).substring(2, 9);
  request.headers['X-Transaction-ID'] = transactionId;

  setSentryTag([
    { tagName: 'transaction_id', tagValue: transactionId },
    { tagName: 'organization', tagValue: store.getState('organization').organization?.name },
  ], { url: request?.url, data: request?.data });

  return request;
});

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401 && error?.config?.headers?.Authorization) {
      const originalRequest = error.config;

      if (originalRequest.retry) {
        store.dispatchAction('ui', 'showToastError', i18n.t('general.messages.has_not_permission'), { root: true });

        return store.dispatchAction('auth', 'logoff');
      }

      if (!isRefreshing) {
        isRefreshing = true;
        try {
          let token = '';
          const response = await axios.post(`${process.env.ENDPOINT}/refresh-token`, null, {
            headers: {
              Authorization: '',
            },
            withCredentials: true,
          });
          if (response.data.data) {
            token = response.data.data.access_token;
          }

          setTimeout(() => {
            onRefreshed(token);
          }, 10);

          store.dispatchAction('auth', 'setToken', token);
        } catch {
          store.dispatchAction('auth', 'setSessionOff', true);

          return store.dispatchAction('auth', 'logoff');
        } finally {
          isRefreshing = false;
        }
      }

      return addSubscribeTokenRefresh(originalRequest);
    }

    return Promise.reject(error);
  },
);

export default http;
